<template>
  <div class="d-flex flex-column fill-height background pa-5">
    <div class="text-h6">Dienst "{{dutyNameDetails}}"</div>
    <div class="text-subtitle-2"> {{formattedDutyDetailsDateOfSelection}}</div>
    <div class="d-flex">
      <div style="width:200px" class="mt-3 mr-5 caption">
        Der nebenstehende Dienst wurde ausgewählt. Die Dienst von - bis Angaben im Formular/in der Tabelle können nachträglich korrigiert werden, weshalb diese nicht zwingend den Dienstdetails entsprechen müssen.
      </div>
      <div style="width:700px;height:250px;overflow-y:scroll">
        <div v-if="resolvedDutyActivities" class="d-flex col-12 col-sm-6 flex-column align-start">
          <table class="table text-left caption">
            <thead>
            <th class="pr-4">Linie</th>
            <th class="pr-4">Kurs</th>
            <th class="pr-4">von</th>
            <th class="pr-4">bis</th>

            <th></th>
            <th></th>
            <th></th>
            <th></th>
            </thead>
            <tbody class="text-left">
            <tr v-for="(da, ind) in resolvedDutyActivities" :key="ind">
              <td class="text-left">
                <div v-if="da.line">{{ da.line }}</div>
              </td>
              <td>
                <div v-if="da.course">{{ da.course }}</div>
              </td>
              <td>
                <div class="outlined-box" :style="getColor(da._startNo)">{{ da.from }} {{ da.fromLocation }}</div>
              </td>

              <td>
                <div class="outlined-box" :style="getColor(da._endNo)">{{ da.to }} {{ da.toLocation }}</div>
              </td>

              <td class="px-3">
                <div v-if="da.activityShortname === 'Umlaufstück'">Umlaufstück</div>
                <div v-else>{{ da.activityShortname }}</div>
              </td>
              <td>{{ da.longName }}</td>
              <td>{{ da.activityLongname }}</td>
              <td>{{ da.fzgNummer || da.daFzgNummer }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import wsMixin from "@/modules/customerVbzWorksheet/wsMixin";

export default {
  name: 'DutyPartsView',
  mixins: [wsMixin],
  props: {
    dutySelection: {
      type: Object,default:()=>{return {}}
    },
    dutyNameDetails:String,
  },

  data() {
    return {
      dutyActivities_: this.dutyActivities,
    };
  },
  computed: {

    resolvedDutyActivities() {
      return this.dutySelection.resolvedDutyActivities;
    },
    selectedDutyParts() {
      return this.dutySelection.resolvedDutyActivities;
    },
    dutySelectionPart() {
      return this.dutySelection.dutySelectionPart;
    },
    formattedDutyDetailsDateOfSelection(){

      if (this.dutySelection && this.dutySelection.dutyDetailsDateOfSelection){
        let date=new Date(this.dutySelection.dutyDetailsDateOfSelection);
        return `gemäss Stand ${date.toLocaleString()} (Zeit der Selektion dieses Dienstes)`
      }
      return '';
    }
  },
  methods: {
    getColor(index) {
      if (index === this.dutySelectionPart) {
        return { background: this.colorPalette[index] };
      }
      return {};
    },
  },
};
</script>
<style scoped>
.outlined-box {
  border-radius: 6px;
  width: 140px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.theme--light .outlined-box {
  border: 1px solid #d0d0d0;
}
.theme--dark .outlined-box {
  border: 1px solid #505050;
}
</style>